import { useState } from 'react';
import ActionBarTooltip from '@atoms/new/ActionBarTooltip';
import { getLiveLayoutColors } from './helper/presentationLive';
import useOutsideClickDetect from '@lib/hooks/useOutsideClickDetect';
import SlideImage from '@components/Presentation/main/Sidebar/SlideImage';
import { DotsThreeIcon as MoreHorizIcon } from '@phosphor-icons/react';

const TrackInteractions = ({
  resultView = false,
  user = {},
  moderationMode = false,
  layoutTheme = 'light',
  linkLibraryCount,
  numOfParticipants,
  setOpenTrackModal,
  quickQuestionsCount,
  markLinkLibraryAsViewed,
  markQuickQuestionsAsViewed,
  markNumOfParticipantsAsViewed,
  toggleHeatmap = () => { },
}) => {
  const isBgLight = layoutTheme === 'light';
  const colors = getLiveLayoutColors(layoutTheme);

  const getBoxClass = () => {
    return `h-12 w-12 rounded-full ${colors.containerColor} ${colors.svgColor} ${colors.hoverBg}`;
  };

  const [showTrackFeatures, setShowTrackFeatures] = useState(false);

  const toggleTrackFeatures = () => {
    setShowTrackFeatures(!showTrackFeatures);
  };

  useOutsideClickDetect(showTrackFeatures, 'trackFeature', toggleTrackFeatures);

  return (
    <div className={'mt-0 mb-0 ml-0.5'}>
      <ActionBarTooltip content="Features that continuously track the chat" placement='right'>
        <div
          id='trackerText'
          style={{ color: isBgLight ? '#000' : '#FFF' }}
          className='flex items-center font-semibold text-xs leading-3 text-neutral-50 mb-2 justify-center'>
          Track
        </div>
      </ActionBarTooltip>

      <ActionBarTooltip content="StreamAlive found these questions in the chat..." placement='right'>
        <div className={`flex items-center justify-center ${getBoxClass()} relative`}
          onClick={() => {
            markQuickQuestionsAsViewed();
            setOpenTrackModal('Quick Questions');
          }}>
          <SlideImage
            key={`slide-${'Quick Questions'}`}
            slideType={'Quick Questions'}
            color={layoutTheme === 'dark' ? '#FFFFFF' : '#111111'}
            svgWidth="24"
            svgHeight="24"
            roundedClassName="rounded-full"
          />
          {quickQuestionsCount > 0 &&
            <p className='absolute -top-1 -right-2 rounded-full h-fit min-w-[22px] text-xs bg-[#D4D4D4] border-2 border-white text-center text-black p-[1px]'>
              {quickQuestionsCount}
            </p>
          }
        </div>
      </ActionBarTooltip>

      <div id='trackFeature' className={'absolute'} onMouseEnter={toggleTrackFeatures} onMouseLeave={toggleTrackFeatures} >
        <div className={'w-full flex items-center mt-2 h-10'}>
          <div className={`flex items-center justify-center ${getBoxClass()}`}>
            <MoreHorizIcon size={35} />
          </div>

          {showTrackFeatures && (
            <div
              className={`ml-2 flex gap-2 items-center justify-center rounded-full ${colors.containerColor} ${colors.svgColor}`}>

              <ActionBarTooltip content="StreamAlive found these links in the chat..." placement='bottom'>
                <div className={`flex items-center justify-center ${getBoxClass()} relative`}
                  onClick={() => {
                    markLinkLibraryAsViewed();
                    setOpenTrackModal('linkLibrary');
                  }}>
                  <SlideImage
                    slideType={'linkLibrary'}
                    color={layoutTheme === 'dark' ? '#FFFFFF' : '#111111'}
                    svgWidth="24"
                    svgHeight="24"
                    roundedClassName="rounded-full"
                  />
                  {linkLibraryCount > 0 &&
                    <p className='absolute -top-1 -right-2 rounded-full h-fit min-w-[22px] text-xs bg-[#D4D4D4] border-2 border-white text-center text-black p-[1px]'>
                      {linkLibraryCount}
                    </p>
                  }
                </div>
              </ActionBarTooltip>

              <ActionBarTooltip content="Your top commenters are.." placement='bottom'>
                <div className={`flex items-center justify-center ${getBoxClass()} relative`}
                  onClick={() => {
                    setOpenTrackModal('fantasticFans');
                    markNumOfParticipantsAsViewed();
                  }}
                >
                  <SlideImage
                    slideType={'fantasticFans'}
                    color={layoutTheme === 'dark' ? '#FFFFFF' : '#111111'}
                    svgWidth="24"
                    svgHeight="24"
                    roundedClassName="rounded-full"
                  />
                  {numOfParticipants > 0 &&
                    <p className='absolute -top-1 -right-2 rounded-full h-fit min-w-[22px] text-xs bg-[#D4D4D4] border-2 border-white text-center text-black p-[1px]'>
                      {numOfParticipants}
                    </p>
                  }
                </div>
              </ActionBarTooltip>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrackInteractions;
